export default {
  path: '/my-account',
  component: () => import('@/views/my-account/my-account-router.vue'),
  children: [
    {
      path: '',
      name: 'MyAccount',
      component: () => import('@/views/my-account/page/MyAccount.vue'),
      meta: {
        name: 'บัญชีของฉัน',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'my-account-edit',
      name: 'MyAccountEdit',
      component: () => import('@/views/my-account/page/MyAccountEdit.vue'),
      meta: {
        name: 'บัญชีของฉัน',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'change-password',
      name: 'MyAccountChangePassword',
      component: () => import('@/views/my-account/page/MyAccountChangePassword.vue'),
      meta: {
        name: 'บัญชีของฉัน',
        icon: '/icons/setting.svg',
        auth: true
      }
    }

  ]
}
